// extracted by mini-css-extract-plugin
module.exports = {"message":"clinical-portal-3__EmptyMessage__message"};